import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { EnhancedTripDetailInitStepDeclaration } from "./Steps/EnhancedTripDetailInitStep";

export const EnhancedTripDetailStartupFlow = new FlowDefinition(
  "EnhancedTripDetailFlow"
);

EnhancedTripDetailStartupFlow.addStep(EnhancedTripDetailInitStepDeclaration);

EnhancedTripDetailStartupFlow.setStartStep("EnhancedTripDetailInit_Step");

export const EnhancedTripDetailStartupStepDefinition = new StepDefinition({
  stepName: "EnhancedTripDetailFlow",
  stepFlow: EnhancedTripDetailStartupFlow,
  contextIsolation: false,
});
